import React from "react";
import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import wandaLogo from "../../../../assets/pdf/WandaLogoFull.png";
import serviceDateIcon from "../../../../assets/pdf/ServiceDateIcon.png";
import pdfPersonIcon from "../../../../assets/pdf/pdfPerson.png";
import pdfBookindIdIcon from "../../../../assets/pdf/bookingIcon.png";
import { IDownloadPdfTrips } from "../../../../types/DownloadPdfTypes";
import moment from "moment";
import DownloadPdfBodyView from "../DownloadPdfBody/DownloadPdfBodyView";

const styles = StyleSheet.create({
  pageTitleText: {
    fontSize: 20,
    fontWeight: 700,
    fontStyle: "normal",
    marginTop: 10,
    color: "#000000",
    lineHeight: 28,
    marginLeft: 48,
  },
  wandaLogo: {
    width: 211,
    height: 56,
    margin: 32,
    marginBottom: "48px",
  },
});

const DownloadPdfHeader: React.FC = () => {
  return (
    <View>
      <View>
        <Image src={wandaLogo} style={styles.wandaLogo} />
      </View>
    </View>
  );
};

export default DownloadPdfHeader;
